module.exports = __webpack_public_path__ + "static/media/m_hairstyle_pompadour_front_shadow.5363a56a.png";